import { BoRole, PermissionType } from "models/BO/BoRole";
import { networkGlobals, makeRequest } from "./networkUtils";
import { PageNumber } from "../accessNumbers";


/** get list of roles */
export const getRolesDO = async (allBrands:boolean = false): Promise<BoRole[]> => {
    return await makeRequest(`roles?allBrands=${allBrands}`);
};


export const getMyRolesDO = async (): Promise<BoRole[]> => {
    return await makeRequest(`roles/my`);
};


/** get a specific role */
export const getRoleDO = async ( id): Promise<BoRole> => {
    return await makeRequest(`roles/${id}?`);
};


/** update role */
export const updateRoleDo = async (data:Partial<BoRole>, id:number) => {
    ;
    const res = await makeRequest(`roles/${id}`, {
        method: 'PUT',
        body:  data 
    });
    ;
    return res?.status;
};

/** update role */
export const updatePermissions = async ( permissions, id) => {
    const res = await makeRequest(`roles/${id}/permissions`, {
        method: 'PUT',
        body: { permissions }
    });
    return res?.status;
};

/** delete role */
export const deleteRoleDO = async (id) => {
    ;
    const res = await makeRequest(`roles/${id}?`, {
        method: 'DELETE'
    });
    ;
    return res?.status;
};

/** create a new role */
export const postRoleDO = async (data:Partial<BoRole>) => {
    const res = await makeRequest('roles', {
        method: 'POST',
        body: data
    });
    ;
    return res?.status;
};

/** copy role */
export const copyRoleDO = async (brands, id, userID) => {
    const res = await makeRequest(`roles/${id}/copy`, {
        method: 'POST',
        body: { userID }
    });
    return res?.status;
};

